module.exports = __webpack_public_path__ + "img/Character_Amber_Thumb.5b485364.png";